export const StatusOptions = {
  rejected: {
    value: -2,
    label: 'rejected',
  },
  pending: {
    value: -1,
    label: 'pending',
  },
  normal: {
    value: 1,
    label: 'active',
  },
  closed: {
    value: 9,
    label: 'closed',
  },
}